import React from 'react';

import connectionVisibilitySetOffIcon from 'assets/connection-visibility-set-off.svg';
import connectionVisibilitySetOnIcon from 'assets/connection-visibility-set-on.svg';

const SidebarConnectionVisibilityIcon = ({
  active,
  className,
  id,
  onClick,
}: {
  active: boolean;
  className?: string;
  id?: string;
  onClick: () => void;
}): JSX.Element => (
  <img
    alt="connection-visibility-icon"
    className={className}
    id={id}
    onClick={onClick}
    src={
      active ? connectionVisibilitySetOffIcon : connectionVisibilitySetOnIcon
    }
  />
);

export default SidebarConnectionVisibilityIcon;
